// Supermarket.js
import React, { useEffect, useState, useRef } from 'react';
import './Supermarket.css';
import { useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowUp,
  faBath,
  faBolt,
  faBookOpen,
  faBoxesStacked,
  faCapsules,
  faCarSide,
  faCartShopping,
  faGem,
  faLayerGroup,
  faRulerCombined,
  faShoePrints,
  faShirt,
  faStore,
  faMobile
} from '@fortawesome/free-solid-svg-icons';
import data from './Data.json';

// â”€â”€â”€ Per-business configuration â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Banner images: high-quality Unsplash CDN URLs (free, no auth needed)
const BUSINESS_CONFIG = {
  supermarkets: {
    theme: 'supermarkets',
    icon: faCartShopping,
    bannerUrl: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=1400&q=80&fit=crop',
bannerAlt: 'Family shopping in a bright supermarket with stocked racks',
    eyebrow: 'Retail & Grocery ERP',
    heroTitleLine1: 'Smarter Billing for',
    heroTitleAccent: 'Modern Supermarkets',
    heroDeck: 'End-to-end ERP built for Indian supermarkets — barcode billing, GST, WhatsApp, loyalty, and multi-branch all in one.',
    sectionTag: 'Supermarkets',
    sectionHeading: 'Everything Your Supermarket',
    sectionHeadingAccent: ' Needs to Thrive',
    sectionSub: 'From checkout counters to cloud reports Auditus-iERP covers every corner of your store.',
  },
  pharmacy: {
    theme: 'pharmacy',
    icon: faCapsules,
    bannerUrl: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=1400&q=80&fit=crop',
    bannerAlt: 'Female pharmacist holding medicine tablet box',
    eyebrow: 'Pharmacy & Medical ERP',
    heroTitleLine1: 'Precision Management for',
    heroTitleAccent: 'Pharmacies & Medical Stores',
    heroDeck: 'FSSAI-ready, batch-expiry tracking, doctor-prescription billing, and drug schedule compliance — all automated.',
    sectionTag: 'Pharmacy',
    sectionHeading: 'Clinical-Grade Tools for',
    sectionHeadingAccent: ' Every Pharmacy',
    sectionSub: 'Regulatory compliance, drug inventory, and patient records handled with zero friction.',
  },
  textile: {
    theme: 'textile',
    icon: faRulerCombined,
    bannerUrl: 'https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=1400&q=80&fit=crop',
    bannerAlt: 'Colorful fabric rolls in a textile showroom',
    eyebrow: 'Textile & Fabric ERP',
    heroTitleLine1: 'Fabric-to-Bill Automation for',
    heroTitleAccent: 'Textile Businesses',
    heroDeck: 'Manage metres, shade-codes, GST on fabrics, and multi-brand showrooms with one powerful system.',
    sectionTag: 'Textile',
    sectionHeading: 'Woven-In Features for',
    sectionHeadingAccent: ' Textile Retailers',
    sectionSub: 'From roll-wise inventory to designer label printing purpose-built for the fabric trade.',
  },
  FMCG: {
    theme: 'FMCG',
    icon: faBoxesStacked,
    bannerUrl: 'https://images.unsplash.com/photo-1621303837174-89787a7d4729?w=1400&q=80&fit=crop',
    bannerAlt: 'FMCG product distribution warehouse',
    eyebrow: 'FMCG Distribution ERP',
    heroTitleLine1: 'Route-to-Market Power for',
    heroTitleAccent: 'FMCG Distributors',
    heroDeck: 'Streamline primary & secondary sales, beat planning, van-loading, scheme management, and retailer claims.',
    sectionTag: 'FMCG',
    sectionHeading: 'Distribution Intelligence for',
    sectionHeadingAccent: ' FMCG Leaders',
    sectionSub: 'Real-time field visibility, scheme automation, and seamless principal reporting all unified.',
  },
  automobile: {
    theme: 'automobile',
    icon: faCarSide,
    bannerUrl: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1400&q=80&fit=crop',
    bannerAlt: 'Sleek automobile showroom with luxury vehicles',
    eyebrow: 'Automobile & Spare Parts ERP',
    heroTitleLine1: 'Drive-Ahead Software for',
    heroTitleAccent: 'Auto Dealers & Workshops',
    heroDeck: 'Vehicle sales, spare-parts inventory, job-cards, insurance renewals, and AMC tracking — built for the auto industry.',
    sectionTag: 'Automobile',
    sectionHeading: 'High-Performance Tools for',
    sectionHeadingAccent: ' Auto Businesses',
    sectionSub: 'From showroom floor to service bay one system to manage your entire auto enterprise.',
  },
  garments: {
    theme: 'garments',
    icon: faShirt,
    bannerUrl: 'https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?w=1400&q=80&fit=crop',
    bannerAlt: 'Fashion garments showroom with colourful clothing racks',
    eyebrow: 'Fashion & Garments ERP',
    heroTitleLine1: 'Style-Forward Operations for',
    heroTitleAccent: 'Fashion Retailers',
    heroDeck: 'Size-colour matrix, season-wise buying, fast-fashion billing, and loyalty programmes — designed for fashion retail.',
    sectionTag: 'Garments',
    sectionHeading: 'Tailored Solutions for',
    sectionHeadingAccent: ' Fashion Businesses',
    sectionSub: 'Run your collection launches, size inventory, and brand-wise margins effortlessly.',
  },
  footwear: {
    theme: 'footwear',
    icon: faShoePrints,
    bannerUrl: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=1400&q=80&fit=crop',
    bannerAlt: 'Premium footwear on display in a shoe store',
    eyebrow: 'Footwear Retail ERP',
    heroTitleLine1: 'Step-Up Technology for',
    heroTitleAccent: 'Footwear Retailers',
    heroDeck: 'Manage sizes, brands, season stock, exchange schemes, and omni-channel sales for your shoe business.',
    sectionTag: '👟 Footwear',
    sectionHeading: 'Best-Fit Features for',
    sectionHeadingAccent: ' Footwear Stores',
    sectionSub: 'Size-wise stock, brand dashboards, and fast billing — perfectly fitted for footwear.',
  },
  sanitary: {
    theme: 'sanitary',
    icon: faBath,
    bannerUrl: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=1400&q=80&fit=crop',
    bannerAlt: 'Modern bathroom showroom with sanitaryware displays',
    eyebrow: 'Sanitary & Bath ERP',
    heroTitleLine1: 'Crystal-Clear Operations for',
    heroTitleAccent: 'Sanitary Ware Businesses',
    heroDeck: 'Manage tiles, fittings, brand catalogues, project billing, and dealer networks for your sanitary business.',
    sectionTag: '🚿 Sanitary',
    sectionHeading: 'Spotless Solutions for',
    sectionHeadingAccent: ' Sanitary Retailers',
    sectionSub: 'From catalogue-based ordering to project site deliveries — everything flows clean.',
  },
  plywood: {
    theme: 'plywood',
    icon: faLayerGroup,
    bannerUrl: 'https://images.unsplash.com/photo-1541123437800-1bb1317badc2?w=1400&q=80&fit=crop',
    bannerAlt: 'Timber and plywood sheets stacked in a lumber yard',
    eyebrow: 'Plywood & Timber ERP',
    heroTitleLine1: 'Solid Foundations for',
    heroTitleAccent: 'Plywood & Timber Dealers',
    heroDeck: 'Sheet-wise inventory, cutting management, brand distribution, contractor accounts, and site billing — all in one.',
    sectionTag: '🪵 Plywood',
    sectionHeading: 'Rock-Solid Features for',
    sectionHeadingAccent: ' Timber Businesses',
    sectionSub: 'Manage sheets, brands, and project accounts with unmatched precision.',
  },
  electrical: {
    theme: 'electrical',
    icon: faBolt,
    bannerUrl: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1400&q=80&fit=crop',
    bannerAlt: 'Electrical components and wiring products display',
    eyebrow: 'Electrical & Hardware ERP',
    heroTitleLine1: 'Power-On Solutions for',
    heroTitleAccent: 'Electrical Retailers & Dealers',
    heroDeck: 'Brand-wise pricing, wiring accessories, contractor accounts, project quotations, and GST billing — fully charged.',
    sectionTag: '⚡ Electrical',
    sectionHeading: 'High-Voltage Features for',
    sectionHeadingAccent: ' Electrical Businesses',
    sectionSub: 'From wire coils to switchgear — manage your entire electrical catalogue with ease.',
  },
  books: {
    theme: 'books',
    icon: faBookOpen,
    bannerUrl: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=1400&q=80&fit=crop',
    bannerAlt: 'Well-organised bookstore shelves with books',
    eyebrow: 'Books & Stationery ERP',
    heroTitleLine1: 'Chapter-by-Chapter Automation for',
    heroTitleAccent: 'Book Stores & Publishers',
    heroDeck: 'ISBN tracking, author-wise inventory, institutional supply, school book lists, and exam-season management — all covered.',
    sectionTag: '📚 Books',
    sectionHeading: 'Page-Turning Features for',
    sectionHeadingAccent: ' Book Retailers',
    sectionSub: 'Manage titles, publishers, school supply, and second-hand trade-ins with scholarly precision.',
  },
  jewellery: {
    theme: 'jewellery',
    icon: faGem,
    bannerUrl: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=1400&q=80&fit=crop',
    bannerAlt: 'Elegant jewellery display with gold and diamond pieces',
    eyebrow: 'Jewellery ERP',
    heroTitleLine1: 'Precision Management for',
    heroTitleAccent: 'Jewellery Stores & Showrooms',
    heroDeck: 'Track gold purity, diamond certification, making charges, inventory by design, and real-time pricing — all in one place.',
    sectionTag: '💍 Jewellery',
    sectionHeading: 'Brilliant Features for',
    sectionHeadingAccent: ' Jewellery Retailers',
    sectionSub: 'Manage ornaments, karats, weight-based pricing, custom orders, and buyback schemes with complete accuracy.',
  },
  ca_firm: {
  theme: 'ca_firm',
  icon: faBookOpen,
  bannerUrl: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1400',
  bannerAlt: 'CA office with financial documents',
  eyebrow: 'CA & Tax ERP',
  heroTitleLine1: 'Smart Compliance for',
  heroTitleAccent: 'CA Firms',
  heroDeck: 'Manage GST, audits, clients, and tax filings with automation.',
  sectionTag: 'CA Firm',
  sectionHeading: 'Professional Tools for',
  sectionHeadingAccent: ' Chartered Accountants',
  sectionSub: 'From client records to compliance everything simplified.'
},
fertilizer: {
  theme: 'fertilizer',
  icon: faStore,
  bannerUrl: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=1400',
  bannerAlt: 'Agriculture fertilizer shop',
  eyebrow: 'Agro Shop ERP',
  heroTitleLine1: 'Smart Solutions for',
  heroTitleAccent: 'Fertilizer Shops',
  heroDeck: 'Manage stock, farmers, and supplier operations efficiently.',
  sectionTag: 'Fertilizer',
  sectionHeading: 'Growth Tools for',
  sectionHeadingAccent: ' Agro Businesses',
  sectionSub: 'From stock to farmer credit everything automated.'
},
mobile_shop: {
  theme: 'mobile_shop',
  icon: faMobile,
  bannerUrl: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=1400',
  bannerAlt: 'Mobile phones showroom',
  eyebrow: 'Mobile Store ERP',
  heroTitleLine1: 'Next-Gen System for',
  heroTitleAccent: 'Mobile Shops',
  heroDeck: 'Track IMEI, manage repairs, and handle fast billing.',
  sectionTag: 'Mobile Shop',
  sectionHeading: 'Smart Features for',
  sectionHeadingAccent: ' Mobile Retailers',
  sectionSub: 'Devices, repairs, and sales all in one system.'
}
};

// â”€â”€â”€ Font Awesome SVG icon paths by keyword â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const FA_ICONS = {
  billing:    { d: 'M0 64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 64v64h64v-64H64zm192 0v64h64v-64H256zm-192 128v64h64v-64H64zm192 0v64h64v-64H256zm-192 128v64h64v-64H64zm192 0v64h64v-64H256z', vb: '0 0 448 512' },
  payment:    { d: 'M64 32C28.7 32 0 60.7 0 96v32H512V96c0-35.3-28.7-64-64-64H64zM512 192H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192zm-336 80c0 8.8-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c8.8 0 16 7.2 16 16zm112 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16z', vb: '0 0 512 512' },
  barcode:    { d: 'M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm120 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm80 16V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H456c-13.3 0-24 10.7-24 24z', vb: '0 0 512 512' },
  gst:        { d: 'M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V192H336c-26.5 0-48-21.5-48-48V0H48zm240 0v144h144L288 0zM64 240c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16z', vb: '0 0 384 512' },
  inventory:  { d: 'M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 64v64h64v-64H64zm192 0v64h64v-64H256zm-192 128v64h64v-64H64zm192 0v64h64v-64H256z', vb: '0 0 448 512' },
  warehouse:  { d: 'M0 336c0 8.8 7.2 16 16 16H48v96c0 17.7 14.3 32 32 32H432c17.7 0 32-14.3 32-32v-96h32c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v16zm112-32h32v-80h32v80h32V176H112v128zm160 0h32v-80h32v80h32V176H272v128zM256 0c-9.5 0-18.7 3.4-26 9.5L6 96H506L282 9.5C274.7 3.4 265.5 0 256 0z', vb: '0 0 512 512' },
  customer:   { d: 'M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z', vb: '0 0 448 512' },
  loyalty:    { d: 'M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z', vb: '0 0 512 512' },
  whatsapp:   { d: 'M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-23.2-115-65.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z', vb: '0 0 448 512' },
  mobile:     { d: 'M16 64C16 28.7 44.7 0 80 0H272c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM176 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64z', vb: '0 0 384 512' },
  report:     { d: 'M32 32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64c0-17.7-14.3-32-32-32zm96 96v192c0 17.7 14.3 32 32 32s32-14.3 32-32V192c0-17.7-14.3-32-32-32s-32 14.3-32 32zm96-64v256c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128 128v128c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32z', vb: '0 0 512 512' },
  purchase:   { d: 'M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512H430c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H458.4L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192H171.7L253.3 35.1z', vb: '0 0 576 512' },
  branch:     { d: 'M48 0C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H352c-17.7 0-32-14.3-32-32V0H48zm304 0v144h144L352 0zM176 352c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v96H176V352z', vb: '0 0 448 512' },
  user:       { d: 'M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z', vb: '0 0 448 512' },
  promotion:  { d: 'M190.5 68.8L225.3 128H224 152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H438.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40H288h-1.3l34.8-59.2C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40zM32 288V464c0 26.5 21.5 48 48 48H240V288H32zm240 0V512H432c26.5 0 48-21.5 48-48V288H272z', vb: '0 0 512 512' },
  delivery:   { d: 'M0 80C0 53.5 21.5 32 48 32h336c26.5 0 48 21.5 48 48V240l0 0c-17 0-33.3 5.4-46.9 15.4L304 322.3V176H80V384H192l0 40.7L121.3 480H48C21.5 480 0 458.5 0 432V80zM80 176V128H304V176H80zM464 208c-8.8 0-16 7.2-16 16v112h-96c-8.8 0-16 7.2-16 16v96h-48c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48 16 48c17.7 0 32-14.3 32-32V224c0-8.8-7.2-16-16-16z', vb: '0 0 576 512' },
  security:   { d: 'M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z', vb: '0 0 448 512' },
  backup:     { d: 'M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z', vb: '0 0 512 512' },
  ecommerce:  { d: 'M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm160 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V224zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V224zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V224z', vb: '0 0 576 512' },
  expense:    { d: 'M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c44.2 0 80 35.8 80 80v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-17.7-14.3-32-32-32H144c-17.7 0-32 14.3-32 32v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8c0-44.2 35.8-80 80-80zm-8-96a56 56 0 1 1 112 0A56 56 0 1 1 136 192z', vb: '0 0 512 512' },
  tag:        { d: 'M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z', vb: '0 0 448 512' },
  default:    { d: 'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm0 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z', vb: '0 0 512 512' },
};

function pickIcon(title) {
  const t = title.toLowerCase();
  if (t.includes('billing') || t.includes('bill')) return FA_ICONS.billing;
  if (t.includes('payment') || t.includes('settle') || t.includes('credit')) return FA_ICONS.payment;
  if (t.includes('barcode') || t.includes('scan') || t.includes('tagging')) return FA_ICONS.barcode;
  if (t.includes('label') || t.includes('printing') || t.includes('print')) return FA_ICONS.tag;
  if (t.includes('gst') || t.includes('tax') || t.includes('compliance') || t.includes('hsn')) return FA_ICONS.gst;
  if (t.includes('inventory') || t.includes('stock') || t.includes('dead stock') || t.includes('audit')) return FA_ICONS.inventory;
  if (t.includes('warehouse') || t.includes('godown') || t.includes('shelf')) return FA_ICONS.warehouse;
  if (t.includes('whatsapp') || t.includes('sms') || t.includes('communication')) return FA_ICONS.whatsapp;
  if (t.includes('mobile') || t.includes('android') || t.includes('app') || t.includes('field')) return FA_ICONS.mobile;
  if (t.includes('customer') || t.includes('patient') || t.includes('member') || t.includes('crm')) return FA_ICONS.customer;
  if (t.includes('loyalty') || t.includes('reward') || t.includes('heart')) return FA_ICONS.loyalty;
  if (t.includes('report') || t.includes('analytic') || t.includes('dashboard') || t.includes('insight')) return FA_ICONS.report;
  if (t.includes('purchase') || t.includes('procure') || t.includes('order')) return FA_ICONS.purchase;
  if (t.includes('supplier') || t.includes('vendor')) return FA_ICONS.purchase;
  if (t.includes('branch') || t.includes('multi-branch') || t.includes('location')) return FA_ICONS.branch;
  if (t.includes('user') || t.includes('access') || t.includes('shift') || t.includes('counter')) return FA_ICONS.user;
  if (t.includes('promotion') || t.includes('scheme') || t.includes('discount') || t.includes('offer') || t.includes('festival')) return FA_ICONS.promotion;
  if (t.includes('delivery') || t.includes('dispatch') || t.includes('logistics') || t.includes('route') || t.includes('van')) return FA_ICONS.delivery;
  if (t.includes('security') || t.includes('narcotic') || t.includes('temperature')) return FA_ICONS.security;
  if (t.includes('backup') || t.includes('data backup')) return FA_ICONS.backup;
  if (t.includes('ecommerce') || t.includes('e-commerce') || t.includes('online') || t.includes('website')) return FA_ICONS.ecommerce;
  if (t.includes('expense') || t.includes('petty') || t.includes('cash')) return FA_ICONS.expense;
  if (t.includes('return') || t.includes('exchange') || t.includes('alteration')) return FA_ICONS.tag;
  if (t.includes('weight') || t.includes('purity') || t.includes('karat') || t.includes('gold') || t.includes('diamond') || t.includes('gem')) return FA_ICONS.tag;
  return FA_ICONS.default;
}

// â”€â”€â”€ Helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function getGroupBySlug(slug) {
  return Object.keys(data).find(
    (key) =>
      (data[key].slug && data[key].slug === slug) ||
      key.toLowerCase() === slug?.toLowerCase()
  );
}

function parseCardNumber(title) {
  const m = title.match(/^(\d+)\./);
  return m ? m[1] : null;
}

function stripNumber(title) {
  return title.replace(/^\d+\.\s*/, '');
}

function displayName(g) {
  return g.charAt(0).toUpperCase() + g.slice(1);
}

// â”€â”€â”€ Component â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function Supermarket() {
  const [searchParams, setSearchParams] = useSearchParams();

  const urlSlug = searchParams.get('group');
  const selectedGroup = urlSlug ? getGroupBySlug(urlSlug) || 'supermarkets' : 'supermarkets';
  const groupData = data[selectedGroup];
  const cfg = BUSINESS_CONFIG[selectedGroup] || BUSINESS_CONFIG.supermarkets;

  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 768);
  const [showPopup, setShowPopup] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const sidebarRef = useRef(null);
  const mainScrollRef = useRef(null);
  const menuIconRef = useRef(null);
  const holdTimer = useRef(null);
  const HOLD_MS = 5000;

  const scrollMainToTop = (behavior = 'auto') => {
    if (!mainScrollRef.current) return;
    mainScrollRef.current.scrollTo({ top: 0, behavior });
    setShowScrollTop(false);
  };

  // Apply per-business theme to <html>
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', cfg.theme);
    return () => document.documentElement.removeAttribute('data-theme');
  }, [cfg.theme]);

  const handleGroupClick = (group) => {
    const slug = data[group].slug || group;
    scrollMainToTop();
    setSearchParams({ group: slug });
    if (window.innerWidth <= 768) setShowSidebar(false);
  };

  const handleMainScroll = (event) => {
    const nextValue = event.currentTarget.scrollTop > 280;
    setShowScrollTop((prev) => (prev === nextValue ? prev : nextValue));
  };

  // Ctrl+F9 popup
  useEffect(() => {
    const onKey = (e) => {
      if (e.ctrlKey && e.key === 'F9') { e.preventDefault(); setShowPopup(true); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  // 5-second touch hold popup (mobile)
  useEffect(() => {
    const start = () => {
      if (window.innerWidth <= 768) {
        if (holdTimer.current) clearTimeout(holdTimer.current);
        holdTimer.current = setTimeout(() => { setShowPopup(true); holdTimer.current = null; }, HOLD_MS);
      }
    };
    const clear = () => { if (holdTimer.current) { clearTimeout(holdTimer.current); holdTimer.current = null; } };
    document.addEventListener('touchstart', start);
    document.addEventListener('touchend', clear);
    document.addEventListener('touchcancel', clear);
    return () => {
      document.removeEventListener('touchstart', start);
      document.removeEventListener('touchend', clear);
      document.removeEventListener('touchcancel', clear);
      if (holdTimer.current) clearTimeout(holdTimer.current);
    };
  }, []);

  // Close sidebar on outside click (mobile)
  useEffect(() => {
    const handler = (e) => {
      if (
        showSidebar && window.innerWidth <= 768 &&
        sidebarRef.current && !sidebarRef.current.contains(e.target) &&
        menuIconRef.current && !menuIconRef.current.contains(e.target)
      ) setShowSidebar(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [showSidebar]);

  // Resize handler
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 768 && !showSidebar) setShowSidebar(true);
      else if (window.innerWidth <= 768 && showSidebar) setShowSidebar(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [showSidebar]);

  useEffect(() => {
    if (!mainScrollRef.current) return;
    mainScrollRef.current.scrollTo({ top: 0, behavior: 'auto' });
    setShowScrollTop(false);
  }, [selectedGroup]);

  const handleCopyLink = (group) => {
    const slug = data[group].slug || group;
    const fullUrl = `${window.location.origin}/Industrial-specification?group=${slug}`;
    navigator.clipboard.writeText(fullUrl).then(() => {
      alert(`Copied: ${fullUrl}`);
      setShowPopup(false);
    });
  };

  if (!groupData) return <div style={{ padding: 40, fontFamily: 'sans-serif' }}>Loadingâ€¦</div>;

  const featureCount = groupData.features.length;

  return (
    <div className="supermarket-layout">

      {/* â”€â”€ Mobile menu toggle â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <div className="menu-icon-container" ref={menuIconRef}>
        <button
          className="menu-icon"
          onClick={() => setShowSidebar(!showSidebar)}
          aria-label="Toggle sidebar"
        >
          {showSidebar ? 'âœ•' : 'â˜°'}
        </button>
      </div>

      {/* â”€â”€ Sidebar â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <aside
        ref={sidebarRef}
        className={`sidebar-group-select${showSidebar ? ' open' : ''}`}
      >
        <p className="sidebar-heading">Business Types</p>
        <nav className="sidebar-nav">
          {Object.keys(data).map((group) => {
            const c = BUSINESS_CONFIG[group] || {};
            return (
              <button
                key={group}
                className={`sidebar-btn${selectedGroup === group ? ' active' : ''}`}
                onClick={() => handleGroupClick(group)}
              >
                <span className="sidebar-btn-icon" aria-hidden="true">
                  <FontAwesomeIcon icon={c.icon || faStore} />
                </span>
                {displayName(group)}
              </button>
            );
          })}
        </nav>
      </aside>

      {/* â”€â”€ Main Content â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <div className="main-content-area">
        <div
          ref={mainScrollRef}
          className="main-scroll"
          onScroll={handleMainScroll}
        >

          {/* Hero Banner */}
          <div className="hero-banner" key={`banner-${selectedGroup}`}>
            <img
              className="hero-banner-img"
              src={cfg.bannerUrl}
              alt={cfg.bannerAlt}
              loading="eager"
            />
            <div className="hero-banner-overlay" />
            <div className="hero-banner-content">
              <div className="hero-eyebrow">
                <span className="hero-eyebrow-dot" />
                {cfg.eyebrow}
              </div>
              <h1 className="hero-title">
                {cfg.heroTitleLine1}{' '}
                <em>{cfg.heroTitleAccent}</em>
              </h1>
              <p className="hero-desc">{cfg.heroDeck}</p>
              <div className="hero-chips">
                {groupData.about.highlights.map((item, idx) => (
                  <span className="hero-chip" key={idx}>
                    <span className="hero-chip-dot" />
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Features Section */}
          <div className="page-body" key={`body-${selectedGroup}`}>
            <div className="section-intro">
              <div>
                <div className="section-tag">{cfg.sectionTag}</div>
                <h2 className="section-heading">
                  {cfg.sectionHeading}
                  <span>{cfg.sectionHeadingAccent}</span>
                </h2>
                <p className="section-sub">{cfg.sectionSub}</p>
              </div>
              <div className="section-count">
                {featureCount} Modules Included
              </div>
            </div>

            <div className="features-list-supermarket">
              {groupData.features.map((feature) => {
                const cleanTitle = stripNumber(feature.title);
                const icon = pickIcon(cleanTitle);
                return (
                  <div className="feature-card-supermarket" key={feature.title}>
                    <div className="card-inner">
                      <div className="card-header">
                        <div className="card-heading-row">
                          <span className="card-icon-badge">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox={icon.vb} fill="currentColor" aria-hidden="true">
                              <path d={icon.d}/>
                            </svg>
                          </span>
                          <h3>{cleanTitle}</h3>
                        </div>
                      </div>
                      <p>{feature.description}</p>
                      <ul>
                        {feature.points.map((point, i) => (
                          <li key={i}>
                            <span className="li-check" aria-hidden="true">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor">
                                <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                              </svg>
                            </span>
                            {point}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

        </div>
      </div>

      <button
        type="button"
        className={`scroll-top-btn${showScrollTop ? ' visible' : ''}`}
        onClick={() => scrollMainToTop('smooth')}
        aria-label="Scroll to top"
      >
        <FontAwesomeIcon icon={faArrowUp} aria-hidden="true" />
      </button>

      {/* â”€â”€ Copy-link popup (Ctrl+F9 / 5s hold) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <h2>Copy Group Link</h2>
            {Object.keys(data).map((group) => {
              const c = BUSINESS_CONFIG[group] || {};
              return (
                <button key={group} className="popup-btn" onClick={() => handleCopyLink(group)}>
                  <FontAwesomeIcon
                    icon={c.icon || faStore}
                    className="popup-btn-icon"
                    aria-hidden="true"
                  />
                  {displayName(group)}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default Supermarket;

